import AppLabel, { Level } from "@/features/ui/app-label";
import { OrderRuleStatus } from "@/features/line-sheet-sets/hooks/use-update-order-rule-status";

// 오더룰 적용 상태 → 뱃지. NO_ORDER_RULE 은 보여줄 게 없어 뱃지를 그리지 않는다.
const LABEL_BY_STATUS: Record<
  Exclude<OrderRuleStatus, "NO_ORDER_RULE">,
  { nameKey: string; level: Level }
> = {
  PENDING: { nameKey: "common:condition_apply_required", level: "ERROR" },
  APPLIED: { nameKey: "common:condition_apply_completed", level: "SUCCESS" },
  SKIPPED: { nameKey: "common:condition_apply_skipped", level: "GRAY" },
};

export interface OrderRuleStatusLabelProps {
  status?: OrderRuleStatus | null;
  // 프리오더(SEASON)는 컨디션 적용 대상이 아니라 뱃지를 감춘다.
  isHidden?: boolean;
  // status 가 없는 응답(구버전 API/캐시된 payload)용 폴백 값.
  // 적용 시각이 있으면 완료, 없고 오더룰이 있으면 대기로 본다.
  fallbackAppliedAt?: string | null;
  fallbackHasOrderRule?: boolean;
}

function resolveStatus({
  status,
  fallbackAppliedAt,
  fallbackHasOrderRule,
}: OrderRuleStatusLabelProps): OrderRuleStatus | null {
  if (status) {
    return status;
  }
  if (fallbackAppliedAt) {
    return "APPLIED";
  }
  return fallbackHasOrderRule ? "PENDING" : null;
}

export default function OrderRuleStatusLabel(props: OrderRuleStatusLabelProps) {
  const status = resolveStatus(props);
  if (props.isHidden || !status || status === "NO_ORDER_RULE") {
    return null;
  }
  const label = LABEL_BY_STATUS[status];
  if (!label) {
    return null;
  }
  return (
    <AppLabel nameKey={label.nameKey} level={label.level} isToUpper={false} />
  );
}
